export default __webpack_public_path__ + "static/media/evcgLong.15a03964.jpg";